import { render, staticRenderFns } from "./python.vue?vue&type=template&id=45bd2ed5&"
import script from "./python.vue?vue&type=script&lang=js&"
export * from "./python.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports